import { useNotificationsData } from "./notifications/useNotificationsData";
import { createNotificationActions } from "./notifications/notificationActions";
import { useAuth } from "@/contexts/AuthContext";

export type { Notification } from "./notifications/types";

export function useNotifications() {
  const { user } = useAuth();
  const {
    notifications,
    setNotifications,
    loading,
    error,
    unreadCount,
    setUnreadCount,
  } = useNotificationsData();

  const actions = createNotificationActions(
    user,
    notifications,
    setNotifications,
    setUnreadCount,
  );

  return {
    notifications,
    loading,
    error,
    unreadCount,
    ...actions,
  };
}
